import { PayloadAction } from '@reduxjs/toolkit';

import { WritableAutoConfiguratorState } from '../slice';

type InitializePayload = {
  siteCode: string;
  dataImportUuid: string;
  snapQuoteUuid: string;
  alphaQuoteUuid: string;
};

export function initialize(
  state: WritableAutoConfiguratorState,
  action: PayloadAction<InitializePayload>,
) {
  const { siteCode, snapQuoteUuid, dataImportUuid, alphaQuoteUuid } =
    action.payload;
  const normalizedSiteCode = siteCode.toLowerCase();

  state.siteCode = normalizedSiteCode;
  state.quoteContext.snapQuoteUuid = snapQuoteUuid;
  state.quoteContext.alphaQuoteUuid = alphaQuoteUuid;
  state.pendingRecalculationCount = 0;
  state.pendingCalculationRequestIdByLineItemUuid = {};
  state.calculationErrorsByLineItemUuid = {};
  state.lastSaveDateTime = null;
  state.lastImportUuidsBySiteCode[normalizedSiteCode] = dataImportUuid;
}
